import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  where,
  runTransaction,
} from "firebase/firestore";
import { DB } from "src/auth/FirebaseContext";
import { DRIVING_COURSE_COLLECTION, USER_COLLECTION } from "../utils/collectionsIds";
import { drivingCourseStatusTypes } from "../utils/constants";
export const getUsers = async (options, config) => {
  try {
    let queryParams;
    if (options.userType) {
      queryParams = query(
        collection(DB, USER_COLLECTION),
        where("userType", "==", options.userType),
      );
    } else {
      queryParams = query(collection(DB, USER_COLLECTION));
    }
    let res = await getDocs(queryParams);
    let docs = [];
    res.forEach((doc) => {
      docs.push({ id: doc.id, ...doc.data() });
    });
    return docs;
  } catch (err) {
    console.log(`${err}`);
    throw new Error(err);
  }
};

export const getUser = async (id) => {
  try {
    const docRef = doc(DB, USER_COLLECTION, id);
    let res = await getDoc(docRef);
    if (res.exists()) {
      let user = { id: res.id, ...res.data() };
      return user;
    } else {
      throw new Error("No user found");
    }
  } catch (err) {
    console.log(`${err}`);
    throw new Error(err);
  }
};
export const observeUserById = (id, callback) => {
  const docRef = doc(DB, USER_COLLECTION, id);
  let res = onSnapshot(docRef, (snap) => {
    if (snap.exists()) {
      let user = { id: snap.id, ...snap.data() };
      callback(user);
    } else {
      callback(null);
    }
  });
  return res;
};

export const observeUsers = (options, callback) => {
  let queryParams = query(collection(DB, USER_COLLECTION));
  options?.forEach((option) => {
    if (!option?.value) return;
    if (!option.field) return;
    if (
      option.operator === "array-contains-any" &&
      !(Array.isArray(option.value) && option.value.length)
    ) {
      return;
    }
    queryParams = query(queryParams, where(option.field, option.operator || "==", option.value));
  });
  return onSnapshot(
    queryParams,
    (snap) => {
      callback(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    },
    (err) => console.log(err),
  );
};
export const assignInstructorToStudent = async (studentId, instructorId) => {
  try {
    await runTransaction(DB, async (t) => {
      const [student, instructor] = await Promise.all([
        t.get(doc(DB, USER_COLLECTION, studentId)),
        t.get(doc(DB, USER_COLLECTION, instructorId)),
      ]);
      if (!student.exists() || !instructor.exists()) {
        throw new Error("User not found");
      }
      if (student.data().userType !== "student") {
        throw new Error("User is not a student");
      }
      if (instructor.data().userType !== "instructor") {
        throw new Error("User is not an instructor");
      }
      t.update(doc(DB, USER_COLLECTION, studentId), {
        drivingInstructor: instructorId,
      });
      t.set(doc(DB, DRIVING_COURSE_COLLECTION, studentId), {
        studentId,
        instructorId,
        assistantInstructorId: null,
        registrationDate: Date.now(),
        status: drivingCourseStatusTypes.pending,
        completedlessons: 0,
        extraParameterResults: {
          drivingPhases_extraParameterId: "bool", //true = passed, false = failed
        },
      });
    });
    return { error: null };
  } catch (err) {
    console.log(`${err}`);
    return { error: err.message };
  }
};
export const archiveUser = async (id) => {
  try {
    await runTransaction(DB, async (t) => {
      const user = await t.get(doc(DB, USER_COLLECTION, id));
      if (!user.exists()) {
        throw new Error("User not found");
      }
      t.update(doc(DB, USER_COLLECTION, id), {
        archived: true,
      });
    });
    return { error: null };
  } catch (err) {
    console.log(`${err}`);
    return { error: err.message };
  }
};
